export default {
  title: 'Plantillas SMS',

  // Form related
  form: {
    tempName: 'Nombre de Plantilla',
    tempNamePlaceholder: 'Ingrese el nombre de la plantilla',
    country: 'País',
    countryPlaceholder: 'Seleccione el país',
    category: 'Categoría',
    categoryPlaceholder: 'Seleccione la categoría',
    channel: 'Canal',
    channelPlaceholder: 'Seleccione el canal',
    provider: 'Proveedor',
    providerPlaceholder: 'Seleccione el proveedor',
    status: 'Estado',
    statusPlaceholder: 'Seleccione el estado',
    content: 'Contenido de la Plantilla',
    contentPlaceholder: 'Ingrese el contenido de la plantilla, soporta variables: {username}/{vip_level}/{kyc_name}/{nickname}/{promo_pool_id}/{user_points}/{phone_number}',
    shortChain: 'Enlace Corto',
    shortChainPlaceholder: 'Ingrese el enlace corto (opcional)',
    agentCode: 'Código del Agente',
    agentCodePlaceholder: 'Ingrese el código del agente (opcional)',
    loginChannel: 'Canal de Inicio de Sesión',
    loginChannelPlaceholder: 'Seleccione'
  },

  // Country related
  country: {
    PH: 'Filipinas',
    VN: 'Vietnam',
    CN: 'China',
    US: 'Estados Unidos'
  },

  // Table related
  table: {
    tempName: 'Nombre de Plantilla',
    country: 'País',
    category: 'Categoría',
    channel: 'Canal',
    provider: 'Proveedor',
    content: 'Contenido de la Plantilla',
    loginChannel: 'Canal de Inicio de Sesión',
    status: 'Estado',
    actions: 'Acciones'
  },

  // Status related
  status: {
    enabled: 'Habilitado',
    disabled: 'Deshabilitado'
  },

  // Button related
  button: {
    create: 'Crear Plantilla',
    manageCategory: 'Gestionar Categorías',
    test: 'Envío de Prueba'
  },

  // Modal related
  modal: {
    createTitle: 'Crear Plantilla SMS',
    editTitle: 'Editar Plantilla SMS'
  },

  // Template variables related
  variables: {
    title: 'Variables de Plantilla Soportadas',
    tip: 'Haga clic en variables para insertarlas en el contenido de la plantilla',
    username: 'Nombre de Usuario (vacío si no está disponible)',
    vipLevel: 'Nivel VIP (p. ej., VIP3)',
    kycName: 'Nombre KYC (disponible después de la verificación)',
    nickname: 'Apodo (vacío si no está disponible)',
    promoPool: 'Pool de Promoción (p. ej., {promo_pool_7788833399})',
    userPoints: 'Saldo de Puntos del Usuario (Puntos del Usuario)',
    phoneNumber: 'Número de Teléfono del Usuario (desensibilizado)'
  },

  // Validation related
  validation: {
    tempNameRequired: 'Ingrese el nombre de la plantilla',
    countryRequired: 'Seleccione el país',
    categoryRequired: 'Seleccione la categoría',
    channelRequired: 'Seleccione el canal',
    providerRequired: 'Seleccione el proveedor',
    contentRequired: 'Ingrese el contenido de la plantilla',
    statusRequired: 'Seleccione el estado'
  },

  // Message related
  message: {
    queryFailed: 'Error en la consulta',
    createSuccess: 'Creado exitosamente',
    createFailed: 'Error en la creación',
    updateSuccess: 'Actualizado exitosamente',
    updateFailed: 'Error en la actualización',
    deleteSuccess: 'Eliminado exitosamente',
    deleteFailed: 'Error en la eliminación',
    statusUpdateSuccess: 'Estado actualizado exitosamente',
    statusUpdateFailed: 'Error al actualizar el estado'
  },

  // Confirm related
  confirm: {
    delete: '¿Está seguro de que desea eliminar esta plantilla?',
    toggleStatus: '¿Está seguro de que desea cambiar el estado de esta plantilla?'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} registros'
  },

  // Test send related
  test: {
    title: 'Envío de Prueba de SMS',
    templateName: 'Nombre de Plantilla',
    templateContent: 'Contenido de la Plantilla',
    inputLabel: 'Destinatario',
    inputPlaceholder: 'Ingrese el número de teléfono o cuenta de miembro',
    inputHint: 'El sistema identificará automáticamente si ingresó un número de teléfono o cuenta de miembro',
    send: 'Enviar',
    inputRequired: 'Ingrese el número de teléfono o cuenta de miembro',
    success: 'Envío de prueba exitoso',
    failed: 'Error en el envío de prueba',
    error: 'Error en el envío de prueba',
    userNotFound: 'El usuario de prueba no está en nuestro sistema'
  },

  // Category management related
  category: {
    modal: {
      title: 'Gestión de Categoría de Plantilla'
    },
    table: {
      id: 'ID',
      name: 'Nombre de Categoría',
      actions: 'Acciones'
    },
    form: {
      namePlaceholder: 'Ingrese el nombre de la categoría'
    },
    button: {
      create: 'Crear Categoría'
    },
    confirm: {
      delete: '¿Está seguro de que desea eliminar esta categoría?',
      deleteDesc: 'Esta acción no se puede deshacer, proceda con precaución'
    },
    defaultActivity: 'Actividad',
    defaultReminder: 'Recordatorio',
    allCategories: 'Todas las Categorías',
    nameRequired: 'Ingrese el nombre de la categoría',
    nameExists: 'El nombre de la categoría ya existe',
    queryFailed: 'Error al consultar categorías',
    createSuccess: 'Categoría creada exitosamente',
    createFailed: 'Error al crear categoría',
    deleteSuccess: 'Categoría eliminada exitosamente',
    deleteFailed: 'Error al eliminar categoría'
  }
};
